// extracted by mini-css-extract-plugin
export const root = "j_c";
export const title = "j_h";
export const description = "j_j";
export const inputRoot = "j_k";
export const input = "j_l";
export const buttonRoot = "j_m";
export const submitButton = "j_n";